export const shouldShowMessengerChatReveal = ({
  currentChat,
  isHistoryLoaded = true,
  isLoadingMessages = false,
  messagesStatus = '',
} = {}) => {
  if (!currentChat?._id) return false;
  if (messagesStatus === 'error') return false;
  if (isHistoryLoaded === false) return true;

  return Boolean(isLoadingMessages || messagesStatus === 'loading');
};
